import { storeManager } from '@pressreader/appstore';
import { authStoreSection } from '@pressreader/src/app/authentication/store/constants';

import { saga } from './sagas';

function registerFeature() {
    storeManager.addFeature(authStoreSection, undefined, saga);
}

export { registerFeature };
